<main class="mat-elevation-z8">
  <div class="description-column">
    <img src="./assets/cp-logo.png" />
    <p i18n
      >Das <a href="https://entscheidungsnavi.de" target="_blank" rel="noopener" i18n-href>Entscheidungsnavi</a> ist ein Webtool zur
      Unterstützung reflektierter Entscheidungen. Mit dem Cockpit können Mitglieder des
      <a href="https://reflektiert-entscheiden.de/" target="_blank" rel="noopener">Fördervereins Reflektiert Entscheiden e.&nbsp;V.</a> auf
      erweiterte Funktionen zugreifen, die die Nutzung des Entscheidungsnavis im Rahmen der Lehre an Schulen und Universitäten
      erleichtern.</p
    >
    <p i18n
      >Falls Du Interesse an dem Einsatz des Entscheidungsnavis in der Lehre hast, kannst Du uns gerne
      <a href="https://reflektiert-entscheiden.de/kontakt/" target="_blank" rel="noopener">hier</a> kontaktieren.</p
    >
  </div>
  <div class="login-column">
    <form class="fields-wrapper" #actualForm="ngForm" (ngSubmit)="login()" [formGroup]="loginForm" data-cy="login_form">
      <h1 i18n>Anmeldung</h1>

      <mat-form-field>
        <mat-label i18n>E-Mail-Adresse</mat-label>
        <input matInput type="email" formControlName="email" />
        @if (shouldShowSeedUsers) {
          <button
            mat-icon-button
            matSuffix
            color="accent"
            [matMenuTriggerFor]="seedUserMenu"
            (click)="$event.stopPropagation()"
            type="button"
            ><mat-icon>recent_actors</mat-icon></button
          >
        }
        <mat-menu #seedUserMenu>
          @for (seedUser of seedUsers; track seedUser) {
            <button mat-menu-item (click)="loginWithSeedUser(seedUser)">
              {{ seedUser.name }}
            </button>
          }
        </mat-menu>
      </mat-form-field>
      <mat-form-field>
        <mat-label i18n>Passwort</mat-label>
        <input matInput type="password" formControlName="password" />
      </mat-form-field>

      <button
        mat-raised-button
        color="primary"
        type="submit"
        [dtOverlayProgress]="loginForm.disabled"
        [disabled]="(!loginForm.valid && !actualForm.submitted) || loginForm.disabled"
        i18n
        >Anmelden</button
      >

      @if (loginForm.getError('server-error') === 'rate-limit') {
        <mat-error i18n>Du hast in kurzer Zeit zu viele Anfragen gestellt. Bitte versuche es später noch einmal.</mat-error>
      }
      @if (loginForm.getError('server-error') === 'credentials') {
        <mat-error i18n>Die eingegebene Kombination aus E-Mail und Passwort ist falsch.</mat-error>
      }
      @if (loginForm.getError('server-error') === 'something') {
        <mat-error i18n>Bei der Übertragung der Daten ist ein Fehler aufgetreten.</mat-error>
      }

      <a (click)="resetPassword()" class="password-reset" i18n>Passwort vergessen?</a>
    </form>
  </div>
</main>

<footer>
  <a href="../../en/" i18n-href i18n>English</a>
  <a href="https://entscheidungsnavi.de/privacy" i18n-href target="_blank" rel="noopener" i18n>Datenschutz</a>
  <a href="https://entscheidungsnavi.de/sitenotice" i18n-href target="_blank" rel="noopener" i18n>Impressum</a>
</footer>
